<template>

	<div>
		<div class="header-item">
			<h1>Dashboard</h1>
		</div>

		<Dashboard :type="type"></Dashboard>

	</div>

</template>

<script>

import Dashboard from '../components/dashboard/Dashboard.vue'

export default {
	name: 'dashboard',
	components: {
		'Dashboard': Dashboard
	},

	data () {
		return {
			type: 'main'
		}
	}
}
</script>
